import { getApiGalaxyServer } from 'services';
import {
  SearchMembersByFieldsPayload,
  SearchMembersByFieldsResponse,
} from 'TeamModule/api/searchMembersByFieldsApi';

export type GetMembersForExportPayload = SearchMembersByFieldsPayload;

export interface GetMembersForExportErrorResponse {
  message: string;
  error: string;
  statusCode: number;
}

export type GetMembersForExportResponse = SearchMembersByFieldsResponse;

export const getMembersForExportApi = ({
  params,
  token,
  config,
}: BaseApiParams<SearchMembersByFieldsPayload>) =>
  getApiGalaxyServer(`/lookup/members/searchByFields`, { ...config, params: params as any }, token);

export default getMembersForExportApi;
